export interface TeamMember {
    id: string
    firstName: string
    lastName: string
    avatar: string
    proImage?: string
    proImageAlt?: string
    jobTitle: string
    bio?: string
    linkedin?: string
}

export interface HistoryItem {
    year: string
    title: string
    description: string
    icon: string
}

export interface ValueItem {
    title: string
    description: string
    icon: string
}

export interface PedagogyFeature {
    title: string
    description: string
    icon: string
}

export interface SchoolCertification {
    id: string
    name: string
    logo: string
    type: number
    clickBehavior: number
    targetUrl?: string
    certificateImage?: string
    requirementText?: string
    orderIndex: number
}

export const useSchool = () => {
    const config = useRuntimeConfig()
    const apiBase = config.public.apiBase

    const getTeam = async (): Promise<TeamMember[]> => {
        try {
            const data = await $fetch<TeamMember[]>(`${apiBase}/oxoweb/school/team`)
            return data || []
        } catch (e) {
            console.error('Error fetching school team:', e)
            return []
        }
    }

    // These remain static for now - could be moved to Settings API later
    const getHistory = () => {
        return [
            {
                year: '2023',
                title: 'La Genèse',
                description: 'Lancement du projet OXO avec une vision claire : révolutionner l\'apprentissage du développement à Narbonne.',
                icon: 'fas fa-lightbulb'
            },
            {
                year: '2024',
                title: 'Première Promotion',
                description: 'Accueil des premiers étudiants et inauguration du campus numérique.',
                icon: 'fas fa-rocket'
            },
            {
                year: '2025',
                title: 'Expansion',
                description: 'Ouverture de nouvelles spécialisations et partenariats avec les entreprises locales.',
                icon: 'fas fa-chart-line'
            }
        ]
    }

    const getValues = async (): Promise<ValueItem[]> => {
        const info = await getSchoolInfo()
        return info?.values || []
    }

    const getPedagogyFeatures = async (): Promise<PedagogyFeature[]> => {
        const info = await getSchoolInfo()
        return info?.pedagogy || []
    }

    const getSchoolInfo = async () => {
        try {
            const data = await $fetch<any>(`${apiBase}/oxoweb/school/info`)
            // The API returns history, pedagogy, values, etc.
            return {
                history: data.history || [],
                values: data.values || [],
                pedagogy: data.pedagogy || [],
                address: data.address || '',
                phone: data.phone || '',
                email: data.email || '',
                socials: data.socials || {},
                whoAreWe: data.whoAreWe || ''
            }
        } catch (e) {
            console.error('Error fetching school info:', e)
            return null
        }
    }

    const getSchoolBranding = async () => {
        try {
            const data = await $fetch<any>(`${apiBase}/oxoweb/school/branding`)
            return {
                logo: data.logo || '',
                logoAlt: data.logoAlt || '',
                favicon: data.favicon || ''
            }
        } catch (e) {
            console.error('Error fetching school branding:', e)
            return { logo: '', logoAlt: '', favicon: '' }
        }
    }
    const getCertifications = async (): Promise<SchoolCertification[]> => {
        try {
            const data = await $fetch<SchoolCertification[]>(`${apiBase}/oxoweb/certifications`)
            return data || []
        } catch (e) {
            console.error('Error fetching certifications:', e)
            return []
        }
    }

    return {
        getHistory,
        getValues,
        getTeam,
        getPedagogyFeatures,
        getSchoolInfo,
        getSchoolBranding,
        getCertifications
    }
}

